module.exports = __webpack_public_path__ + "media/entities/3005-5d1ff86f.png";